import React from "react";

function ProjectCellCustomer({ cell, row }) {
  return (
    <div className="inner-tables-infos">
      <span className="normalTitle">{cell}</span>
      <span className="subTitle">{row.NameCity}</span>
    </div>
  );
}

export default ProjectCellCustomer;